export {default as CreateCandidateProfile} from './CreateCandidateProfile.connect';
